import React from "react";
import ReactDOM from "react-dom/client";
import "./admin.css";
// import "./styles/global.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./redux/store";
import { AuthProvider } from "./AuthContext";
import { silenceDebugLogs } from "./utils/quietLogs";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "./index.css";
import "izitoast/dist/css/iziToast.min.css";

silenceDebugLogs();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <AuthProvider>
      <App />
    </AuthProvider>
  </Provider>,
);
